import * as Highcharts from 'highcharts';

/** Exposes the plot box as CSS variables so overlays (legends, buttons) can sit on the plot. */
export function syncPlotBoxVars(
  chart: Highcharts.Chart,
  hostSelector: string
): void {
  const host = chart.container?.closest<HTMLElement>(hostSelector);
  if (!host) {
    return;
  }
  const right = chart.chartWidth - chart.plotLeft - chart.plotWidth;
  const bottom = chart.chartHeight - chart.plotTop - chart.plotHeight;
  host.style.setProperty('--plot-top', `${chart.plotTop}px`);
  host.style.setProperty('--plot-left', `${chart.plotLeft}px`);
  host.style.setProperty('--plot-right', `${right}px`);
  host.style.setProperty('--plot-bottom', `${bottom}px`);
}
